import styled from "styled-components/macro";

export default styled.svg({});
